import Vue from 'vue'
import axios from 'axios'

export const custAxios = () => {
  const instance = axios.create({
    headers: {
      Authorization: `Baerer ${window.localStorage.getItem('access-token')}`
    }
  })

  instance.interceptors.response.use(async (config) => config, async (error) => {
    try {
      if (error.response.status === 401) {
        if (error.response.data.error.message && error.response.data.error.message.includes('Unauthorized')) {
          Vue.prototype.$globalStore.dispatch('clearStorage')
          throw error
        }

        throw error
      } else {
        return Promise.reject(error.response)
      }
    } catch (err) {
      return Promise.reject(error.response)
    }
  })

  return instance
}
